<div class="list-group list-group-flush">
  <div class="list-group-item">
    <input
      (ngModelChange)="selectAllChange($event)"
      [ngModel]="selectAll"
      class="small"
      id="selectAll"
      type="checkbox" />
    <label for="selectAll"><span></span> Select All</label>
  </div>
  <div class="list-group-item" *ngIf="options.length === 0">
    <p>No Reports Available.</p>
  </div>
  <div class="list-group-item" *ngFor="let option of options">
    <input
      class="small"
      [disabled]="option.report.Filename == ''"
      [ngModel]="option.selected"
      (ngModelChange)="checkboxChanged($event, option.report.Name)"
      [ngModelOptions]="{ standalone: true }"
      type="checkbox"
      [id]="'checkbox-' + option.report.Name"
      value="true" />
    <label [for]="'checkbox-' + option.report.Name"><span></span> {{ option.report.Name }}</label>
  </div>
</div>
